"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSchema = void 0;
const zod_1 = require("zod");
exports.LanguageSchema = zod_1.z.object({
  id: zod_1.z.number(),
  /** код языка */
  code: zod_1.z.string(),
  /** название языка локализованное */
  title: zod_1.z.string(),
  /** название языка на родном языке */
  title_native: zod_1.z.string(),
  /** URL языкового домена */
  url: zod_1.z.string().url().optional(),
  /**
   * Код голоса для воспроизведения через API ResponsiveVoice
   *
   * @deprecated
   */
  resp_voice: zod_1.z.any().optional(),
  /** Текст для строки перевода */
  domain_switch_description: zod_1.z.string().optional()
});
